import React, { useState } from 'react';
import Constants from '../../../app.constants';
import { buildQueryString } from '../common/utils';

import './privacy-policy.scss';

// TODO: check and opt-in work in backend, figure out implementation in future
const getEndpoint = type => {
  // types: check, opt in, opt out
  const actionId = type === 'check' ? 3 : 4;
  const randomNumber = Math.floor(Math.random() * 10000);
  const redirectURL = encodeURIComponent(`${Constants.HOST}/api/v0/opt_out/rd`);
  const params = {
    action_id: actionId,
    participant_id: 555555,
    rd: redirectURL,
    nocache: randomNumber,
  };
  const baseEndpoint = `${Constants.HOST}/api/v0/opt_out/${type === 'opt in' ? 'opt_in' : 'nai'}/`;
  return baseEndpoint + buildQueryString(params);
};

const OptOut = props => {
  const [isOptedOut, setOptedOut] = useState(false);
  const optOutMessage = 'You are currently opted in';
  const optInMessage = `You are currently opted out. To opt in, please delete your browser's BAMX_Opt_Out cookie`;

  function iframeOptOut(iframeSrc) {
    const iframe = document.createElement('iframe');
    const iframeContainer = document.querySelector('.iframe-container');
    iframe.src = iframeSrc;
    iframeContainer.appendChild(iframe);
  }

  function toggleOptOutCookie() {
    iframeOptOut(getEndpoint('opt out'));
    setOptedOut(!isOptedOut);
  }

  return (
    <div className="opt-out">
      <div
        className={`opt-out-button${isOptedOut ? ' disabled' : ''}`}
        onClick={() => toggleOptOutCookie()}
      >
        {isOptedOut ? 'Opt In' : 'Opt Out'}
      </div>
      <p className="opt-out-text">{`${isOptedOut ? optInMessage : optOutMessage}.`}</p>
      <div className="iframe-container"></div>
    </div>
  );
};

export { getEndpoint, OptOut };
